import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_IdDdWaiverBehaviorSuppPlan = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_IdDdWaiverBehaviorSuppPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>ID/DD Waiver Behavior Support Plan</h3></p>

                <p className='w-750'><h3>Background</h3></p>

                <p>
                    <span className='eleHeader'>Reason for Referral:</span>
                    <textarea id='txtReferral' name='txtReferral' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>History:</span>
                    <textarea id='txtHistory' name='txtHistory' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Psychiatric Diagnoses:</span>
                    <textarea id='txtPsychiatric' name='txtPsychiatric' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Summary of Functional Behavior Assessment</h3></p>

                <p>
                    <span className='eleHeader'>Target Identification Methods:</span>
                    <textarea id='txtTarget' name='txtTarget' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Description of Assessment Procedures:</span>
                    <textarea id='txtDescription' name='txtDescription' className='add-only'></textarea>
                </p>

                <p className='w-750'><hr /></p>

                <p className='w-750'><h3>Target Behavior(s) and Definition:</h3></p>
                
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Behavior(s)</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Definitions</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtBehavior' name='txtBehavior' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDefinitions' name='txtDefinitions' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtBehavior1' name='txtBehavior1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDefinitions1' name='txtDefinitions1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtBehavior2' name='txtBehavior2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDefinitions2' name='txtDefinitions2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtBehavior3' name='txtBehavior3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDefinitions3' name='txtDefinitions3' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><hr /></p>

                <p className='w-750'><h3>Behavioral Findings:</h3></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Behavioral Descripation</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Antecedents</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Consequences</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtBehaviorDesc' name='txtBehavior' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAntecedents' name='txtDefinitions' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConsequences' name='txtDefinitions' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtBehaviorDesc1' name='txtBehavior1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAntecedents1' name='txtDefinitions1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConsequences1' name='txtDefinitions1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtBehaviorDesc2' name='txtBehavior2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAntecedents2' name='txtDefinitions2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConsequences2' name='txtDefinitions2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtBehaviorDesc3' name='txtBehavior3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAntecedents3' name='txtDefinitions3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConsequences3' name='txtDefinitions3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Relevant Findings from Physiological Issues/lllness/lnjury Assessment:</span>
                    <textarea id='txtPhysiological' name='txtPhysiological' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Relevant Findings from Environmental and Setting Assessment:</span>
                    <textarea id='txtEnvironmental' name='txtEnvironmental' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Relevant Findings from Communicative Functions:</span>
                    <textarea id='txtRelevant' name='txtRelevant' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Hypothesis and Summary of Behavior Function(s):</span>
                    <textarea id='txtHypothesis' name='txtHypothesis' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Baseline Data:</span>
                    <textarea id='txtBaseline' name='txtBaseline' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Replacement Behaviors Identified:</span>
                    <textarea id='txtReplacement' name='txtReplacement' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Tracking and Reduction</h3></p>

                <p>
                    <span className='eleHeader'>Behavior Reduction:</span>
                    <textarea id='txtReduction' name='txtReduction' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Baseline Data:</span>
                    <textarea id='txtBaseline1' name='txtBaseline1' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Intervention Expectation:</span>
                    <textarea id='txtIntervention1' name='txtIntervention1' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Replacement/Alternative Behavior:</span>
                    <textarea id='txtReplacement1' name='txtReplacement1' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Review Criteria</span>
                    <textarea id='txtCriteria' name='txtCriteria' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Behavior Reduction:</span>
                    <textarea id='txtReduction2' name='txtReduction2' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Baseline Data:</span>
                    <textarea id='txtBaselineData' name='txtBaselineData' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Intervention Expectation:</span>
                    <textarea id='txtInterventionExpectation' name='txtInterventionExpectation' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Replacement/Alternative Behavior:</span>
                    <textarea id='txtReplacement3' name='txtReplacement3' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Review Criteria:</span>
                    <textarea id='txtReview3' name='txtReview3' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Behavior Reduction:</span>
                    <textarea id='txtReduction3' name='txtReduction3' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Baseline Data:</span>
                    <textarea id='txtBaselineData1' name='txtBaselineData1' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Intervention Expectation:</span>
                    <textarea id='txtInterventionExpectation1' name='txtInterventionExpectation1' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Replacement/Alternative Behavior:</span>
                    <textarea id='txtReplacement31' name='txtReplacement31' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Review Criteria:</span>
                    <textarea id='txtReview31' name='txtReview31' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Objective(s)</h3></p>

                <table>
                    <tr>
                        <td className='w-30'>1.</td>
                        <td className='w-720'>
                            <input type='text' id='txtObjective' name='txtObjective' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>2.</td>
                        <td className='w-720'>
                            <input type='text' id='txtObjective1' name='txtObjective1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>3.</td>
                        <td className='w-720'>
                            <input type='text' id='txtObjective2' name='txtObjective2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-30'>4.</td>
                        <td className='w-720'>
                            <input type='text' id='txtObjective3' name='txtObjective3' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Staff Instruciions</h3></p>

                <p>
                    <span className='eleHeader'>Preventive Measures:</span>
                    <textarea id='txtPreventiveMeasures' name='txtPreventiveMeasures' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Replacement Behavior/Alternative Skill Training:</span>
                    <textarea id='txtReview31Replacement' name='txtReview31Replacement' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Consequence Strategies</span>
                    <textarea id='txtReview31Consequence' name='txtReview31Consequence' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Procedural Safeguards:</span>
                    <textarea id='txtReview31Procedural' name='txtReview31Procedural' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Medication Side Effects of Concern:</span>
                    <textarea id='txtReview31Medication' name='txtReview31' className='add-only'></textarea>
                </p>

                <h4>Agreements and Signatures</h4>

                <p>
                    I agree with the content of this Plan and give consent for its implementation. I have received a copy 
                    of the plan. I understand the behavior management techniques that will be used with this program. I may 
                    terminate the program at any time.
                </p>
                <table>
                    <tr>
                        <td className='signature w-400'></td>
                        <td className='signature w-300'></td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Person:</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-400'></td>
                        <td className='signature w-300'></td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Person/Legal Representative:</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                </table>
                <p>
                    I agree to implement the Plan as described. If any modifications are necessary, I will 
                    contact the person/family before making any changes. I will ensure staff is trained before terminating my services.
                </p>
                <table>
                    <tr>
                        <td className='signature w-400'></td>
                        <td className='signature w-300'></td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Behavior Support Consultant:</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                </table>
                <p>
                    I agree to the contents of this Plan and will support the Consultant/Interventionist as needed to 
                    ensure implementation of the Plan. Appropriate staff will receive training to ensure the Plan continues, 
                    as needed, after the Consultant/Interventionist terminates services.
                </p>
                <table>
                    <tr>
                        <td className='signature w-400'></td>
                        <td className='signature w-300'></td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Program Director:</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-400'></td>
                        <td className='signature w-300'></td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Signature of Behavior Consultant/Credential</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











